
<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<!-- <form [formGroup]="form" (ngSubmit)="onSaveAction()" class="k-form-inline"> -->
<form [formGroup]="disciplineForm"  class="k-form-inline">

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="discipline_name">Discipline Name</label>
    <div class="col-8">
      <input type="text" id="discipline_name" formControlName="discipline_name" class="form-control" appAutoFocus>
      <div *ngIf="discipline_name?.invalid" class="alert alert-danger">
        <div *ngIf="discipline_name?.errors?.['required']">Discipline Name is required.</div>
      </div>
    </div>
  </div>


</form>

<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="disciplineForm.invalid">Save</button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>
